import React, { useState, useEffect } from 'react';
import {
    Modal,
    i18n,
    tokens,
    Text
} from '@simplybenefits/sb-ui-library';

const styles = {
    descriptionText: {
        marginBottom: 20
    },
    accountContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 20,
        gap: 20
    },
    splitsContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 70
    },
    splitItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    }
};


/**
 * Modal component for viewing all commission splits for advisors
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {boolean} props.loader - Loading state for the modal
 * @param {Function} props.getAllAdvisorCommissionSplits - Function to fetch commission splits data
 * @returns {JSX.Element} The modal component
 */
const ViewAllCommissionSplitsModal = ({
    open,
    onClose,
    loader,
    getAllAdvisorCommissionSplits
}) => {
    const [ commissionSplits, setCommissionSplits ] = useState([]);

    useEffect(() => {

        /**
         * Fetches commission splits data when modal opens
         * @returns {Promise<void>}
         */
        const fetchCommissionSplits = async () => {
            const advisorCommissionSplits = await getAllAdvisorCommissionSplits();
            setCommissionSplits(advisorCommissionSplits);
        };

        if (open) {
            fetchCommissionSplits();
        } 
    }, [ open ]);

    return (
        <Modal
            testid="view-all-commission-splits-modal"
            open={ open }
            onClose={ onClose }
            title={ i18n.t(tokens.labels.advisor.commissionSplits) }
            loader={loader}
            allowBackdropClose={true}
        >
            <Text customStyle={styles.descriptionText}>
                { i18n.t(tokens.labels.advisor.reviewCommissionSplitsVerbiage) }
            </Text>
            {
                commissionSplits.length > 0
                    ? (
                        commissionSplits.map((account) => (
                            <div style={styles.accountContainer} key={account.accountID}>
                                <Text mediumLarge bold>
                                    {account.accountName}
                                </Text>
                                <div style={styles.splitsContainer}>
                                    {
                                        account.splits?.length > 0
                                            ? (
                                                account.splits.map((split) => (
                                                    <div style={styles.splitItem} key={split.advisorID}>
                                                        <Text medium bold>
                                                            {split.advisorName}
                                                        </Text>
                                                        <Text medium>
                                                            {`${ split.splitPercentage }%`}
                                                        </Text>
                                                    </div>
                                                ))
                                            )
                                            : null
                                    }
                                </div>
                            </div>
                        ))
                    )
                    : null
            }
        </Modal>
    );
};

export default ViewAllCommissionSplitsModal;